module.exports = __webpack_public_path__ + "img/slider-img5.52662fe7.jpg";